export function useSortConversion(objects: any) {
  let result = "";
  if (!objects) return "";
  if (objects.field === "contentType") {
    result = "content_type";
  } else if (objects.field === "depositedAt") {
    result = "time_started";
  } else if (objects.field === "timeTaken") {
    result = "time_taken";
  } else if (objects.field === "statusUpdatedAt") {
    result = "status_updated_at";
  } else if (objects.field === "status") {
    result = "status";
  } else if (objects.field === "id") {
    result = "id";
  }
  if (objects.type === "asc") return result;
  if (objects.type === "desc") return "d-" + result;
  if (objects.type === "none") return "d-id";
  return "";
}

export function useSortConversionReport(objects: any) {
  let result = "";
  if (!objects) return "";
  if (objects.field === "date") {
    result = "date";
    // } else if (objects.field === "depositedAt") {
    //   result = "time_started";
    // } else if (objects.field === "timeTaken") {
    //   result = "time_taken";
    // } else if (objects.field === "statusUpdatedAt") {
    //   result = "status_updated_at";
    // } else if (objects.field === "status") {
    //   result = "status";
    // } else if (objects.field === "id") {
    //   result = "id";
  }
  if (objects.type === "asc") return result;
  if (objects.type === "desc") return "d-" + result;
  if (objects.type === "none") return "d-date";
  return "";
}
// export function useSortConversion(objects: any) {
//   if (!objects) return "";
//   if (objects.type === "asc") return "+" + objects.field;
//   if (objects.type === "desc") return "-" + objects.field;
//   return "";
// }

// export function useFilterConversion(ArrayObjects: Array<object>) {
//   let result = "";
//   console.log("Filter Objects Were:", ArrayObjects);

//   for (let index = 0; index < ArrayObjects.length; index++) {
//     const item = ArrayObjects[index];
//     if (item["filterText"] !== "")
//       result +=
//         item["fieldName"] + "=" + encodeURIComponent(item["filterText"]) + "&";
//   }
//   return result.slice(0, -1);
// }

// export function useFilterConversion(ArrayObjects: Array<object>) {
//     let result = "";
//     const mappedResults = new Map();
//     ArrayObjects.forEach((element) => {
//       if (element["filterText"])
//         mappedResults.set(
//           element["fieldName"],
//           encodeURIComponent(element["filterText"])
//         );
//     });
//     //transferring_agency=Voluptas%20aut%20eum.&content_type=Transfer
//     return result;
//   }
